<div class="flex min-h-screen layout__bg">
  <div class="w-auto">
    <app-sidebar (collapsedChange)="sidebarCollapsed = $event"></app-sidebar>
  </div>

  <div
    class="flex flex-column layout__content transition-all transition-duration-300"
    [style.margin-left]="sidebarCollapsed ? 'calc(80px + 1.2rem)' : 'calc(240px + 1rem)'"
  >
    <app-topbar></app-topbar>
    <div class="layout__scrollable">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
